<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">组织结构维护</div>
    </zj-layout-header>
    <zj-layout-main>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
        <el-form-item label="应急组织类型" prop="ResourceTypeId" style="display:inline-block;">
          <el-select
            v-model="ruleForm.ResourceTypeId"
            placeholder="请选择所属应急组织类型"
            v-bind:disabled="IsEdit"
            style="width:118rem;"
          >
            <el-option
              v-for="item in options"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组织性质" prop="OrgianiztionTypeId" style="display:inline-block;">
          <el-radio-group
            v-model="ruleForm.OrgianiztionTypeId"
            style="width:118rem;"
            v-bind:disabled="IsEdit"
          >
            <el-radio
              v-for="item in TeamOwnershipoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="应急组织名称" prop="OrgianizationName" style="display:inline-block;">
          <el-input v-model="ruleForm.OrgianizationName" style="width:118rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
      </el-form>
    </zj-layout-main>
    <zj-layout-footer>
      <div style="text-align:center;width:134rem;padding:1rem 1rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
        <el-button @click="resetForm('')" v-show="IsEdit==false">重置</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import ZJApp from '../../../../../app';
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjPersonOrganiztioninfo",
  controller: "EmergencyResource",
  action: "PersonOrganiztioninfo",
  data() {
    return {
      loading: false,
      loadingText: '加载中',
      ruleForm:
        this.$route.query.obj == null
          ? {
              ResourceType: "",
              OrgianiztionType: "",
              OrgianizationName: ""
            }
          : this.$route.query.obj,
      options: [],
      TeamOwnershipoptions: [
        { value: "1", label: "内部组织" },
        { value: "2", label: "外部组织" }
      ],
      rules: {
        OrgianizationName: [
          { required: true, message: "请输入应急组织名称", trigger: "blur" }
        ],
        ResourceTypeId: [
          {
            required: true,
            message: "请选择所属应急组织类型",
            trigger: "change"
          }
        ],
        OrgianiztionTypeId: [
          { required: true, message: "请选择组织性质", trigger: "change" }
        ],

        IsEdit: false
        //desc: [{ required: true, message: "请填写备注", trigger: "blur" }]
      }
    };
  },
  created: function() {
    this.basedatabind();
    this.IsEdit = this.$route.query.type == "edit" ? false : true;
  },
  mounted: function() {},
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        this.config.getUValue("EmergencyService:PersonOrgianiztionType:", "")
      ])
      .then(r => {
        this.options = r[0].JValue;
        this.loading = false;
        return r;
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.loading = false;
      });
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //重置
    resetForm(formName) {
      this.ruleForm = formName;
      //this.$refs[formName].resetFields();
      this.$route.query.obj = null;
    },
    save() {
      this.ruleForm.OrgianiztionTypeId = this.ruleForm.OrgianiztionTypeId.toString();
      if (this.$route.query.obj == null) {
        this.loading = true;
        this.loadingText = '保存中...';
        new MyApis.PersonOrganiztionApi()
          .AddItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.logInfo.ActionName = "应急组织结构添加";
            this.logInfo.LogMessage = r?"应急组织结构添加成功":"应急组织结构添加失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "应急组织结构详情页面";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.loadingText = '保存中...';
        new MyApis.PersonOrganiztionApi()
          .UpdateItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.logInfo.ActionName = "应急组织结构修改";
            this.logInfo.LogMessage = r?"应急组织结构修改成功":"应急组织结构修改失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "应急组织结构详情页面";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    }
  }
};
</script>